import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <header>
            <div className="menuSection">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-md-3 col-sm-12 wow animate__animated animate__fadeInLeft" data-wow-delay=".3s">
                            <div className="header-logo">
                                <Link to="/"><img src="images/logo.png" alt="img" /></Link>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 d-none d-md-block wow animate__animated animate__fadeInDown" data-wow-delay=".3s">
                            <div className="menuSec">
                                <ul id="menu">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about-us"> about us </Link></li>
                                    <li><Link to="/find-lands">Find Land</Link></li>
                                    <li><Link to="/account">List Your Land</Link></li>
                                    <li><Link to="/shop">shop </Link></li>
                                    <li><Link to="/videos">Videos </Link></li>
                                    <li><Link to="/contact-us">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 text-rightwow animate__animated animate__fadeInRight" data-wow-delay=".3s">
                            <div className="header_btn">
                                <Link to="/account" className="theme_btn1">
                                    <div className="theme-btn-inner1">
                                        <div className="btn-text1">Login / Sign up</div>
                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header >
    )
}

export default Header